import { Box, Grid, Typography } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useTranslation } from "react-i18next";
import {
  colorSurface,
  colorBorder,
  colorTextPrimary,
  colorTextMuted,
  radiusCard,
  shadowCard,
} from "src/design/tokens";

interface NoAccessProps {
  /** Overrides the default "Access restricted" heading. */
  title?: string;
  /** Overrides the default explanatory message. */
  message?: string;
  sx?: SxProps;
}

export const NoAccess = ({ title, message, sx }: NoAccessProps) => {
  const { t } = useTranslation();

  return (
    <Grid container justifyContent="center" sx={{ width: "100%", py: 6, px: 2 }}>
      <Grid item xs={12} sm={8} md={5}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: 1.5,
            backgroundColor: colorSurface,
            border: `1px solid ${colorBorder}`,
            borderRadius: radiusCard,
            boxShadow: shadowCard,
            px: { xs: 3, sm: 5 },
            py: { xs: 4, sm: 5 },
            ...sx,
          }}
        >
          <LockOutlinedIcon sx={{ fontSize: 40, color: colorTextMuted }} />
          <Typography
            sx={{ fontWeight: 700, fontSize: "18px", color: colorTextPrimary }}
          >
            {title ?? t("noAccess.title")}
          </Typography>
          <Typography sx={{ fontSize: "14px", color: colorTextMuted }}>
            {message ?? t("noAccess.message")}
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};
